export default "__VITE_ASSET__8TYYi_hJ__"